/**
 * Per-branch stock availability banding for medication chips.
 *
 * A branch holding at most LOW_STOCK_THRESHOLD units is flagged "Agotandose".
 * Client set this to 1 (previously 20), so only a single remaining unit warns.
 */
export const LOW_STOCK_THRESHOLD = 1;

export interface BranchAvailability {
  label: string;
  bg: string;
  color: string;
}

export function getBranchAvailability(name: string, quantity: number): BranchAvailability {
  if (quantity === 0) {
    return { label: `${name}: No Disponible`, bg: '#FFEBEE', color: '#C62828' };
  }
  if (quantity <= LOW_STOCK_THRESHOLD) {
    return { label: `${name}: Agotandose`, bg: '#FFF8E1', color: '#F57F17' };
  }
  return { label: `${name}: Disponible`, bg: '#E8F5E9', color: '#2E7D32' };
}
